<app-fixed-notification *ngIf="missingPaymentAlert && (rolId == 2 || rolId == 3) " class="d-flex justify-content-center mx-3"></app-fixed-notification>

<app-inital-page-mobile *ngIf='size < minimalScreen || isMobile'>
</app-inital-page-mobile>

<app-inital-page-desktop *ngIf='size > minimalScreen && !isMobile'>
</app-inital-page-desktop>

